// extracted by mini-css-extract-plugin
module.exports = {"callout":"BlogCallout_callout___0QWf","title":"BlogCallout_title__sb7nd","icon":"BlogCallout_icon__QlWDW","text":"BlogCallout_text__BS_7T"};